import React, { useState, useEffect } from "react";
import "./TrackJob.css";
import { Paper } from "@mui/material";

const statusStages = [
  {
    id: 1,
    name: "Job Created",
    description: "The report job has been created in the system",
    icon: "📝",
  },
  {
    id: 2,
    name: "Payment Done",
    description: "Payment for the report has been completed",
    icon: "💳",
  },
  {
    id: 3,
    name: "Job Assigned",
    description: "The job has been assigned to a technician",
    icon: "👨‍🔧",
  },
  {
    id: 4,
    name: "Visit Site",
    description: "Technician has visited the site for assessment",
    icon: "🏢",
  },
  {
    id: 5,
    name: "Complete Report",
    description: "Technician has completed the report",
    icon: "✅",
  },
  {
    id: 6,
    name: "Ready to Collect",
    description: "Report is ready for collection/delivery",
    icon: "📦",
  },
];

const initialReports = [
  {
    id: 1,
    title: "Concrete cube test",
    currentStatus: 1,
    customer: "Devinda Construction",
    date: "2024-05-15",
  },
  {
    id: 2,
    title: "Field density test",
    currentStatus: 3,
    customer: "Insee Cement",
    date: "2024-05-18",
  },
  {
    id: 3,
    title: "Aluminium Hardness",
    currentStatus: 5,
    customer: "Kanola Construction",
    date: "2024-05-20",
  },
  {
    id: 4,
    title: "Particle size distribution",
    currentStatus: 2,
    customer: "Ranjith Constuctions",
    date: "2024-05-22",
  },
];

function TrackJob() {
  const [reports, setReports] = useState(initialReports);
  const [selectedReport, setSelectedReport] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredReports = reports.filter(
    (report) =>
      report.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      report.customer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const updateStatus = (reportId, newStatus) => {
    setReports(
      reports.map((report) =>
        report.id === reportId
          ? { ...report, currentStatus: newStatus }
          : report
      )
    );
  };

  return (
    <div
      className="apptrack"
      style={{ marginTop: "20px", alignItems: "center" }}
    >
      <Paper elevation={2} variant="elevation">
        <main className="app-main">
          <div className="reports-grid">
            {filteredReports.map((report) => (
              <div
                key={report.id}
                className={`report-card ${
                  selectedReport?.id === report.id ? "selected" : ""
                }`}
                onClick={() => setSelectedReport(report)}
              >
                <div className="report-header">
                  <h3>{report.title}</h3>
                  <span className="report-date">{report.date}</span>
                </div>
                <p className="report-customer">{report.customer}</p>
                <div className="status-preview">
                  <div className="status-line">
                    {statusStages.map((stage) => (
                      <div
                        key={stage.id}
                        className={`status-dot ${
                          report.currentStatus >= stage.id ? "completed" : ""
                        } ${
                          report.currentStatus === stage.id ? "current" : ""
                        }`}
                        title={stage.name}
                      />
                    ))}
                  </div>
                  <span className="status-text">
                    {
                      statusStages.find((s) => s.id === report.currentStatus)
                        ?.name
                    }
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className={`status-detail ${"visible"}`}>
            {selectedReport && (
              <>
                <div className="detail-header">
                  <h2>{selectedReport.title}</h2>
                  <button
                    className="close-btn"
                    onClick={() => setSelectedReport(null)}
                  >
                    &times;
                  </button>
                </div>

                <div className="report-meta">
                  <div className="meta-item">
                    <span className="meta-label">Customer:</span>
                    <span>{selectedReport.customer}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Date:</span>
                    <span>{selectedReport.date}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Report ID:</span>
                    <span>
                      #{selectedReport.id.toString().padStart(4, "0")}
                    </span>
                  </div>
                </div>

                <div className="timeline-container">
                  {statusStages.map((stage) => (
                    <div
                      key={stage.id}
                      className={`timeline-item ${
                        selectedReport.currentStatus >= stage.id
                          ? "completed"
                          : ""
                      }`}
                    >
                      <div className="timeline-icon">{stage.icon}</div>
                      <div className="timeline-content">
                        <h4>{stage.name}</h4>
                        <p>{stage.description}</p>
                        <p>Date : 2025-05-04</p>
                        {selectedReport.currentStatus === stage.id && (
                          <button
                            className="status-action"
                            onClick={() =>
                              updateStatus(selectedReport.id, stage.id + 1)
                            }
                            disabled={stage.id === statusStages.length}
                          >
                            Mark as {statusStages[stage.id]?.name || "Complete"}
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </main>
      </Paper>
    </div>
  );
}

export default TrackJob;
